import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd15fb7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  class: "container flex-center",
  style: {"height":"50px"}
}
const _hoisted_3 = { class: "flex-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-text" }, "黑鸭", -1))
const _hoisted_5 = {
  class: "flex-center",
  style: {"justify-content":"space-between","flex":"1"}
}
const _hoisted_6 = { class: "flex-center" }
const _hoisted_7 = { class: "hidden-sm-and-up ml20" }
const _hoisted_8 = { class: "navbar-nav hidden-sm-and-down ml20" }
const _hoisted_9 = { class: "flex-center" }
const _hoisted_10 = { class: "flex-center hidden-sm-and-up ml20" }
const _hoisted_11 = {
  key: 0,
  class: "flex-center ml20"
}
const _hoisted_12 = { class: "flex-center ml20" }
const _hoisted_13 = { class: "flex-center cu-pointer" }
const _hoisted_14 = { class: "ml20 flex-center" }
const _hoisted_15 = { class: "flex-center cu-pointer" }

import {onMounted, reactive, ref, watch} from "vue";
import localStorageDb from '@/utils/localStorage';
import AvatarCard from "@/components/AvatarCard.vue";
import {ElMessage, ElMessageBox} from 'element-plus';
import myRequest from "@/utils/request";
import {Search} from "@element-plus/icons-vue";
import {useRouter} from "vue-router";
import {logOut} from "@/api/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const data = reactive({
    hasLogin: false,
    user: {},
    msgCount: 0,
    showMsg: false,
    urlList: [
        {
            text: '社区',
            value: '/'
        },
        {
            text: '企业实录',
            value: '/company/list'
        },
        /*{
            text: '关于我们',
            value: '/about'
        }*/
    ],
    currentNav: '/',
    searchValue: ''
})

const router = useRouter()

onMounted(async () => {
    if (localStorageDb.get("Authorization")) {
        data.hasLogin = true;
        data.user = localStorageDb.get('USER');
        // const msgList = await getUnmessage();
        // data.msgCount = msgList.length;
        // data.showMsg = data.msgCount > 0;
    } else {
        data.hasLogin = false;
    }
})

const toUserCenter = (type: string) => {
    router.push({
        name: 'userCenter',
        params: {
            type: type
        }
    })
}

const updateInfo = (type: string) => {
    router.push({
        name: 'UserUpdate',
        params: {
            type: type
        }
    })
}

const logout = () => {
    ElMessageBox.confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '点错了',
        type: 'warning'
    }).then(() => {
        logOut().then(res => {
            ElMessage.success(res.msg);
            window.location.reload()
        })
    });
};

const changeNav = (nav: string) => {
    data.currentNav = nav;
    router.push(nav);
}

const toSearch = ((value: string | number) => {
    router.push({query: {content: value}, path: '/company/list'})
})

const toTarget = (path: string) => {
    router.push(path)
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_BellFilled = _resolveComponent("BellFilled")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_CaretBottom = _resolveComponent("CaretBottom")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_ChatLineSquare = _resolveComponent("ChatLineSquare")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_Remove = _resolveComponent("Remove")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_image, {
              src: require('@/assets/logo.svg'),
              style: {"width":"40px","height":"40px"}
            }, null, 8, ["src"]),
            _hoisted_4
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_dropdown_item, {
                  onChange: changeNav,
                  modelValue: data.currentNav,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.currentNav) = $event)),
                  options: data.urlList
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.urlList, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.value
              }, [
                _createVNode(_component_router_link, {
                  class: "navbar-nav-item",
                  to: item.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.text), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_input, {
            class: "hidden-sm-and-down ml20 header-search",
            onChange: toSearch,
            modelValue: data.searchValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.searchValue) = $event)),
            placeholder: "输入关键字搜索",
            "prefix-icon": "Search"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_icon, {
              size: 16,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (toTarget('/company/list')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Search))
              ]),
              _: 1
            })
          ]),
          (!data.hasLogin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_router_link, { to: "/account/signup" }, {
                  default: _withCtx(() => [
                    _createTextVNode("注册")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/account/signin",
                  class: "ml20"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("登录")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (data.hasLogin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                false
                  ? (_openBlock(), _createBlock(_component_el_badge, {
                      key: 0,
                      class: "flex-center hidden-sm-and-down ml20 cu-pointer",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (toUserCenter('msg'))),
                      style: {"display":"flex"},
                      "is-dot": true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BellFilled)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_dropdown, { trigger: "click" }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/topics/new" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 发布新主题 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_van_icon, {
                          name: "plus",
                          size: 16
                        }),
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CaretBottom)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_el_dropdown, { trigger: "click" }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (toUserCenter('msg')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_van_icon, { name: "contact" }),
                                  _createTextVNode(" " + _toDisplayString(data.user.nickname), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          false
                            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                key: 0,
                                divided: "",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (toUserCenter('msg')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, { size: 16 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_BellFilled)
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" 我的消息 ")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (toUserCenter('topics'))),
                            divided: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ChatLineSquare)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 我的话题/收藏 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            divided: "",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (updateInfo('info')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Edit)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 修改资料 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            class: "hidden-sm-and-up",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (updateInfo('password')))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Lock)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 修改密码 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            divided: "",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (logout()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Remove)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 退出 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(AvatarCard, {
                          size: 20,
                          avatarUrl: data.user.gravatar,
                          title: true,
                          name: data.user.username
                        }, null, 8, ["avatarUrl", "name"]),
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CaretBottom)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})